import { render, staticRenderFns } from "./OurWidgetToolbar.vue?vue&type=template&id=2272e4ca&"
import script from "./OurWidgetToolbar.vue?vue&type=script&lang=js&"
export * from "./OurWidgetToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports